<template>
  <!-- 立即办理确认：用 $confirmWithScroll，无独立弹窗 DOM -->
  <div style="display: none"></div>
</template>

<script>
export default {
  props: {
    VisibleHesitation: {},
  },
  watch: {
    VisibleHesitation: {
      handler(val) {
        if (val) {
          this.$confirmWithScroll("是否要立即办理？", "立即办理", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$emit("handleUnHesitation");
            })
            .catch(() => {
              this.$emit("handleCloseHesitation");
            });
        }
      },
      immediate: false,
    },
  },
};
</script>
